export const genreGameLocale = {
  en: {
    radio_title: 'Overall',
    region_title: 'Main Genre',
    market_title: 'Genre',
    search: 'Search',
    select_all: 'Select All',
    clear_all: 'Clear All',
    button_region: 'Genre',
    button_market: 'Genre',
    search_none: 'No result found',
    country_no_data: 'No result found',
  },
  cn: {
    radio_title: '聚合数据',
    region_title: '主品类',
    market_title: '品类',
    search: '搜索',
    select_all: '全选',
    clear_all: '清空',
    button_region: '品类',
    button_market: '品类',
    search_none: '无匹配项',
    country_no_data: '无匹配项',
  },
};

export const genreGameRadioOptions = [
  {
    value: 'global',
    text: 'All',
    textCN: '全部',
  },
];

export const genreSplitFlag = '#_#';
